






import listsAdd from "../../contacts/lists/listsAdd.vue";

export default {
    components: {
        listsAdd,
    },
};
